export enum LIST_TYPE_ENUM {
  DASH = 'DASH',
  NUMBER = 'NUMBER',
}
